import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "sonner";

function Gate() {
  const { family } = useAuth();
  if (family === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#faf8f5]">
        <div className="text-center">
          <div className="text-5xl animate-bounce">🎡</div>
          <p className="mt-3 font-bold text-slate-400">Loading your family…</p>
        </div>
      </div>
    );
  }
  return family ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <Gate />
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
